const groupTitles = {
  'corso di inglese': 'Aggiungi ora al tuo Piano, gli extra per approfondire la lingua inglese',
  'registrazioni': 'Rivedi le lezioni che hai perso',
  'office': 'Aggiungi ora al tuo Master i pacchetti extra per padroneggiare al 100% i software di produttività personale per eccellenza',
  'coaching': 'Aggiungi ora al tuo Piano, il servizio di coaching',
  'career service': 'Aggiungi ora al tuo Master il Career Service  per rendere più competitivo il tuo profilo professionale nel mercato nel lavoro'
}

export class UpsellingUtils {
  public static getPackageDescription (sessionPackage: string) {
    switch (sessionPackage.toLowerCase()) {
      case 'easy':
        return 'Con questo piano hai esclusivo accesso in aula e ricevi il diploma una volta completato il Master.';
      
      case 'smart':
        return 'Con questo piano hai esclusivo accesso alle lezioni in live-streaming e ricevi il diploma una volta completato il Master.';
      
      case 'flex':
        return 'Con questo Piano hai esclusivo accesso alle lezioni in live-streaming ma potrai anche recarti in aula per seguire le lezioni in presenza; ricevi il diploma una volta completato il Master.';
    
      default:
        break;
    }
  };

  //TODO: get Risparmio CO2 description
  public static getStaticOptionsDesktop () {
    return [
      [
        {
          title: "Risparmio CO<sub>2</sub>",
          description: "",
          packages: {
            easy: {
              status: "not-included",
              value: null,
            },
            smart: {
              status: "not-included",
              value: null
            },
            flex: {
              status: "included",
              value: "-XX%"
            },
            full: {
              status: "included",
              value: "-XX%"
            },
          }
        },
      ],
      [
        {
          title: "Diploma",
          description: "Ricevi il diploma di Master oppure Master Certificate oppure Master di I o II Livello in base alla tipologia di Master che scegli, rilasciato al termine del percorso formativo con certificazione delle competenze laddove prevista.",
          packages: {
            easy: {
              status: "included",
              priceNoVat: null
            },
            smart: {
              status: "included",
              priceNoVat: null
            },
            flex: {
              status: "included",
              priceNoVat: null
            },
            full: {
              status: "included",
              priceNoVat: null
            }
          }
        },
        {
          title: "Stage",
          description: "È prevista un’ esperienza formativa presso le oltre 1.200 aziende partner nazionali e multinazionali o i player di mercato interessati ad offrire opportunità di stage.",
          packages: {
            easy: {
              status: "included",
              priceNoVat: null
            },
            smart: {
              status: "included",
              priceNoVat: null
            },
            flex: {
              status: "included",
              priceNoVat: null
            },
            full: {
              status: "included",
              priceNoVat: null
            }
          }
        },
        {
          title: "Servizio Placement",
          description: "Nel corso dei mesi d’aula e attraverso colloqui individuali di orientamento, ciascun partecipante viene accompagnato e guidato nell’individuazione del proprio percorso di carriera, sviluppando le soft skills personali, accanto alle competenze tecniche, per operare con successo all’interno delle aziende di settore.",
          packages: {
            easy: {
              status: "included",
              priceNoVat: null
            },
            smart: {
              status: "included",
              priceNoVat: null
            },
            flex: {
              status: "included",
              priceNoVat: null
            },
            full: {
              status: "included",
              priceNoVat: null
            }
          }
        }
      ]
    ];
  }

  //TODO: get Risparmio CO2 description
  public static getStaticOptionsMobile () {
    return [
      {
        easy: [
          {
            title: "Risparmio CO<sub>2</sub>",
            status: "not-included",
            value: null,
            description: ""
          }
        ],
        smart: [
          {
            title: "Risparmio CO<sub>2</sub>",
            status: "not-included",
            value: null,
            description: ""
          }
        ],
        flex: [
          {
            title: "Risparmio CO<sub>2</sub>",
            status: "included",
            value: "-XX%",
            description: ""
          }
        ],
        full: [
          {
            title: "Risparmio CO<sub>2</sub>",
            status: "included",
            value: "-XX%",
            description: ""
          }
        ]
      },
      {
        easy: [
          {
            title: "Diploma",
            status: "included",
            priceNoVat: null,
            description: "Ricevi il diploma di Master oppure Master Certificate oppure Master di I o II Livello in base alla tipologia di Master che scegli, rilasciato al termine del percorso formativo con certificazione delle competenze laddove prevista."
          },
          {
            title: "Stage",
            status: "included",
            priceNoVat: null,
            description: "È prevista un’ esperienza formativa presso le oltre 1.200 aziende partner nazionali e multinazionali o i player di mercato interessati ad offrire opportunità di stage."
          },
          {
            title: "Servizio Placement",
            status: "included",
            priceNoVat: null,
            description: "Nel corso dei mesi d’aula e attraverso colloqui individuali di orientamento, ciascun partecipante viene accompagnato e guidato nell’individuazione del proprio percorso di carriera, sviluppando le soft skills personali, accanto alle competenze tecniche, per operare con successo all’interno delle aziende di settore."
          }
        ],
        smart: [
          {
            title: "Diploma",
            status: "included",
            priceNoVat: null,
            description: "Ricevi il diploma di Master oppure Master Certificate oppure Master di I o II Livello in base alla tipologia di Master che scegli, rilasciato al termine del percorso formativo con certificazione delle competenze laddove prevista."
          },
          {
            title: "Stage",
            status: "included",
            priceNoVat: null,
            description: "È prevista un’ esperienza formativa presso le oltre 1.200 aziende partner nazionali e multinazionali o i player di mercato interessati ad offrire opportunità di stage."
          },
          {
            title: "Servizio Placement",
            status: "included",
            priceNoVat: null,
            description: "Nel corso dei mesi d’aula e attraverso colloqui individuali di orientamento, ciascun partecipante viene accompagnato e guidato nell’individuazione del proprio percorso di carriera, sviluppando le soft skills personali, accanto alle competenze tecniche, per operare con successo all’interno delle aziende di settore."
          }
        ],
        flex: [
          {
            title: "Diploma",
            status: "included",
            priceNoVat: null,
            description: "Ricevi il diploma di Master oppure Master Certificate oppure Master di I o II Livello in base alla tipologia di Master che scegli, rilasciato al termine del percorso formativo con certificazione delle competenze laddove prevista."
          },
          {
            title: "Stage",
            status: "included",
            priceNoVat: null,
            description: "È prevista un’ esperienza formativa presso le oltre 1.200 aziende partner nazionali e multinazionali o i player di mercato interessati ad offrire opportunità di stage."
          },
          {
            title: "Servizio Placement",
            status: "included",
            priceNoVat: null,
            description: "Nel corso dei mesi d’aula e attraverso colloqui individuali di orientamento, ciascun partecipante viene accompagnato e guidato nell’individuazione del proprio percorso di carriera, sviluppando le soft skills personali, accanto alle competenze tecniche, per operare con successo all’interno delle aziende di settore."
          }
        ],
        full: [
          {
            title: "Diploma",
            status: "included",
            priceNoVat: null,
            description: "Ricevi il diploma di Master oppure Master Certificate oppure Master di I o II Livello in base alla tipologia di Master che scegli, rilasciato al termine del percorso formativo con certificazione delle competenze laddove prevista."
          },
          {
            title: "Stage",
            status: "included",
            priceNoVat: null,
            description: "È prevista un’ esperienza formativa presso le oltre 1.200 aziende partner nazionali e multinazionali o i player di mercato interessati ad offrire opportunità di stage."
          },
          {
            title: "Servizio Placement",
            status: "included",
            priceNoVat: null,
            description: "Nel corso dei mesi d’aula e attraverso colloqui individuali di orientamento, ciascun partecipante viene accompagnato e guidato nell’individuazione del proprio percorso di carriera, sviluppando le soft skills personali, accanto alle competenze tecniche, per operare con successo all’interno delle aziende di settore."
          }
        ]
      }
    ];
  }

  public static getGroupTitle(group: string) {
    return groupTitles[group];
  }

  public static getOptionImage (optionTitle: string) {
    switch (optionTitle.toLowerCase()) {
      case '6 lezioni 1-to-1 di inglese':
      case '8 lezioni 1-to-1 di inglese':  
        return '/assets/images/options/6-lezioni-1-to-1-di-inglese.jpg';
      
      case 'piattaforma e-learning ef':
      case 'piattaforma e-learning learnlight live':
        return '/assets/images/options/piattaforma-e-learning-ef.jpg';
      
      case 'office 365':
        return '/assets/images/options/office-365.jpg';
      
      case 'corso excel':
      case 'corso excel + ms copilot':
        return '/assets/images/options/corso-excel.jpg';
      
      case 'career coaching':
        return '/assets/images/options/career-coaching.jpg';

      case 'business coaching':
        return '/assets/images/options/business-coaching.jpg';

      case 'executive coaching':
        return '/assets/images/options/executive-coaching.jpg';

      case 'career service':
        return '/assets/images/options/career-service.jpg';

      default:
        break;
    }
  };

  public static packageDescription = (title: string) => {
    switch (title) {
      case 'easy': 
        return "Con questa opzione hai esclusivo accesso in aula e ricevi il diploma una volta completato lo stage; puoi aggiungere a questo pacchetto lezioni on-demand, workshop individuale di inglese e un pacchetto di lezioni 1-to-1 di inglese.";
      case 'smart': 
        return "Con questa opzione hai esclusivo accesso alle lezioni in live-streaming e ricevi il diploma una volta completato lo stage; puoi aggiungere a questo pacchetto lezioni on-demand, workshop individuale di inglese e un pacchetto di lezioni 1-to-1 di inglese.";
      case 'flex':
        return "Con questa opzione hai esclusivo accesso alle lezioni in live-streaming e potrai insieme recarti anche in aula per seguire le lezioni in presenza; ricevi il diploma una volta completato lo stage. Puoi aggiungere a questo pacchetto lezioni on-demand, workshop individuale di inglese e un pacchetto di lezioni 1-to-1 di inglese."
      default:
        return "";
    }
  }
}
